<template>
  <div class="container">
    <div class="image-wrapper">
      <img :src="image" class="image-item" alt="" ref="imageWrapper" />
      <div class="region-wrapper">
        <VueDraggableResizable
          v-if="regionShow"
          :prevent-deactivation="preventDeactivation"
          v-for="(region, idx) in regions"
          :ref="`regionIdx${idx}`"
          :key="region.id"
          :resizable= false
          :draggable= false
          :active="false"
          :parent="true"
          class="region-item"
          :class="region.type === 'right' ? 'right' : 'error'"
          :w="wrapperSize.w * region.w"
          :h="wrapperSize.h * region.h"
          :x="wrapperSize.w * region.x"
          :y="wrapperSize.h * region.y"
        >
        </VueDraggableResizable>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
  name: "regionResize",
  components: {
    VueDraggableResizable
  },
  props: {
    id: {
      type: Number
    },
    image: {
      type: String
    },
    errorRegions: {
      type: Array
    },
    rightRegions: {
      type: Array
    }
  },
  data() {
    return {
      preventDeactivation: false,
      activedItem: '',
      fixedItem: [],
      regionShow: false,
      wrapperSize: {},
      addDefaultRegion: {
        x: 0.3,
        y: 0.2,
        w: 0.3,
        h: 0.3,
        fixed: true,
        new: true,
        id: 0
      },
      regionsCopy: []
    };
  },
  mounted() {
    // console.log(this.$refs);
    this.computeSize();
  },
  methods: {
    ...mapActions([]),
    onDeActive () {
      // this.activedItem = '';
    },
    computeSize() {
      this.$nextTick(() => {
        const imageWrapper = this.$refs["imageWrapper"];
        let width = imageWrapper.clientWidth;
        let img = new Image();
        img.src = this.image;
        img.onload = () => {
          this.wrapperSize = {
            w: width,
            h: (width / img.width) * img.height
          };
          this.regionShow = true;
        };
      });
    }
  },
  computed: {
    ...mapGetters([]),
    regions () {
      let errorRegions = this.errorRegions;
      let rightRegions = this.rightRegions;
      errorRegions.forEach(a => {
        this.$set(a, 'type', 'error');
      });
      rightRegions.forEach(a => {
        this.$set(a, 'type', 'right');
      });
      return [...errorRegions, ...rightRegions];
    },
    fixedRegion () {
      return this.regionsCopy.filter(a => !a.deleted);
    },
    resetDisabled () {
      // return this.fixedItem.length === 0;
      return this.$_.isEqual(this.regions, this.regionsCopy);
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  .image-wrapper {
    position: relative;
    display: inline-block;
    height: auto;
    padding: 0;
    margin: 0;
    flex: 600px 0 0 ;
    .image-item {
      width: 600px;
      padding: 0;
      margin: 0;
    }
    .region-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .region-item {
        &.right {
          border: 2px solid $success;
        }
        &.error {
          border: 4px solid $danger;
        }
      }
    }
  };
  .handler-wrapper {
    flex: 1;
    display: inline-block;
    vertical-align: top;
    height: 100%;
    margin-left: 20px;
    .btn {
      display: inline-block;
      margin: 5px;
    }
  }
  .btn-in {
    font-size: 32px;
  }
}
</style>
